import { Controller } from '@hotwired/stimulus';
import IMask from 'imask';

// The Brazilian phone field: (00) 0000-0000 for a landline, one digit more
// for a mobile. imask picks by length on its own — the two masks are ordered
// short first, which is how it grows rather than jumping.
//
//   <input data-controller="phone-input">
export default class extends Controller {
  connect() {
    this.mask = IMask(this.element, {
      mask: [
        { mask: '(00) 0000-0000', lazy: true },
        { mask: '(00) 00000-0000', lazy: true },
      ],
    });
  }

  disconnect() {
    this.mask?.destroy();
    this.mask = null;
  }
}
